import React, { Component } from 'react'
import { observer } from "mobx-react";
import 'Styles/usersView/selectUsersToSyncModal.scss';
import UsersStore from 'Stores/usersStore';
import IconsContainer from "Utils/IconsContainer";
import AppStore from 'Stores/AppStore';
import ProductMode from "Utils/ProductMode";
import Enumerable from "linq";
import DateTimePicker from 'Components/Common/DateTimePicker';

class SelectUsersToSyncModal extends Component {

    SelectUser(userLid) {
        UsersStore.selectSyncUsersModalData.selectedUsersLids
            .push(userLid);
    }

    UnSelectUser(userLid) {
        UsersStore.selectSyncUsersModalData.selectedUsersLids =
            UsersStore.selectSyncUsersModalData.selectedUsersLids
                .filter((value, index, array) => value != userLid);
    }

    render() {
        var usersNamesByLids = UsersStore.selectSyncUsersModalData.usersNamesByLids;
        var usersLidsAll = Object.keys(usersNamesByLids);
        var selectedUsersLids =
            Enumerable.from(UsersStore.selectSyncUsersModalData.selectedUsersLids)
                .orderBy(userLid => usersNamesByLids[userLid])
                .toArray();
        var usersLidsCanAdd =
            Enumerable.from(usersLidsAll)
                .where(userLid =>
                    selectedUsersLids.includes(userLid) == false
                )
                .toArray();
        var usersLidsCanAddAfterFilter =
            Enumerable.from(usersLidsCanAdd)
                .where(userLid =>
                    UsersStore.selectSyncUsersModalData.searchAlias == null
                    ||
                    usersNamesByLids[userLid].toLowerCase().indexOf(UsersStore.selectSyncUsersModalData.searchAlias.toLowerCase()) >= 0
                )
                .orderBy(userLid => usersNamesByLids[userLid])
                .toArray();

        let usersToSelect =
            usersLidsCanAdd.length == 0
                ? (
                    <div className='user-list-placeholder'>
                        Выбраны все пользователи
                    </div>
                )
                : usersLidsCanAddAfterFilter.length == 0
                    ? (
                        <div className='user-list-placeholder'>
                            Пользователь не найден
                        </div>
                    )
                    : (
                        usersLidsCanAddAfterFilter.map(userLid => (
                            <div key={userLid}
                                className='user-row-container'
                                onClick={_ => this.SelectUser(userLid)}>
                                <div className='user-name-container'>
                                    {usersNamesByLids[userLid]}
                                </div>
                                {IconsContainer.Get('ci-cross')}
                            </div>
                        ))
                    );

        let selectedUsers =
            selectedUsersLids.length == 0
                ? (
                    <div className='user-list-placeholder'>
                        Не выбран ни один пользователь
                    </div>
                )
                : (
                    selectedUsersLids.map(userLid =>
                        <div key={userLid}
                            className='user-row-container'
                            onClick={_ => this.UnSelectUser(userLid)}>
                            <div className='user-name-container'>
                                {usersNamesByLids[userLid]}
                            </div>
                            {IconsContainer.Get('ci-cross')}
                        </div>
                    )
                );

        var settingsForCheckVisibility = [
            <div
                key='sync-settings-block'
                className='padding-row-block-container settings-line'>
                <div className='setting-name'>
                    Синхронизировать РК / РКПД начиная с:
                </div>
                <DateTimePicker
                    className="start-date-setting"
                    getRenderStore={() => UsersStore.selectSyncUsersModalData.renderStore.from}
                    setRenderStore={val => UsersStore.selectSyncUsersModalData.renderStore.from = val}
                    getValue={() => UsersStore.selectSyncUsersModalData.receiveDocumentsFrom}
                    setValue={val => UsersStore.selectSyncUsersModalData.receiveDocumentsFrom = val}
                    getMinDate={() => new Date('2000-01-01')}
                    getMaxDate={() => new Date(Date.now())}
                    timeVisible={false}
                    isTop={false}
                />
            </div>
        ];
        var settings = ProductMode.FilterControlsParamsObject({
            webKeysVisible: AppStore.productModeSettings?.filterUserSettingsWebKeysVisible,
            webKeysNotVisible: AppStore.productModeSettings?.filterUserSettingsWebKeysNotVisible,
            controlsForFiltering: settingsForCheckVisibility
        });

        return (
            <div className='SelectUsersToSyncModal'>
                {settings}
                <div className='padding-row-block-container'>
                    <div className='users-to-add-and-added-container'>
                        <div className='users-to-add-and-search-container'>
                            <div className='search-input-container'>
                                {IconsContainer.Get('ci-search')}
                                <input className='search-input'
                                    value={UsersStore.selectSyncUsersModalData.searchAlias}
                                    onChange={e => UsersStore.selectSyncUsersModalData.searchAlias = e.target.value} />
                            </div>
                            <div className='users-to-add-container overflowing-element'>
                                {usersToSelect}
                            </div>
                        </div>
                        <div className='users-added-container overflowing-element'>
                            {selectedUsers}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};

export default observer(SelectUsersToSyncModal);